"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const RankingBarMetric_vue_1 = __importDefault(require("@becrop/components/Toolkit/MetricsBoxPlot/vue/components/RankingBarMetric.vue"));
const RankingExtender_vue_1 = __importDefault(require("@becrop/components/Toolkit/MetricsBoxPlot/vue/components/RankingExtender.vue"));
let RankingBarchart = class RankingBarchart extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.SHORT_LIMIT = 12;
        this.SHORT_PART_SIZE = 5;
    }
    get listA() {
        if (this.short) {
            return this.metrics.slice(0, this.SHORT_PART_SIZE);
        }
        // const middleIdx = Math.ceil(this.metrics.length / 2);
        // return this.metrics.slice(0, middleIdx);
        return this.metrics.filter((a) => a.becropScoreChange > 0);
    }
    get listB() {
        if (this.short) {
            return this.metrics.slice(-this.SHORT_PART_SIZE);
        }
        // const middleIdx = Math.ceil(this.metrics.length / 2);
        // return this.metrics.slice(middleIdx);
        return this.metrics.filter((a) => a.becropScoreChange < 0);
    }
    onToggle() {
        this.$emit('togglingBarChart');
    }
    launchThisMetric(m) {
        this.$emit('launchThis', m);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], RankingBarchart.prototype, "metrics", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], RankingBarchart.prototype, "short", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], RankingBarchart.prototype, "dimension", void 0);
RankingBarchart = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            RankingBarMetric: RankingBarMetric_vue_1.default,
            RankingExtender: RankingExtender_vue_1.default,
        },
    })
], RankingBarchart);
exports.default = RankingBarchart;
